let constants = {
    // User states
    USER_EXISTING: 0,
    USER_NEW: 1,

    // Booking dates
    LONG_TERM_DAY_OFFSET: 0,
    DEFAULT_LONG_TERM_DAY_OFFSET: 2,

    // Search
    HOMEPAGE_DEFAULT_RENTAL: screen.width > 480 ? 'long' : 'short',

    // Analytics
    ECOMMERCE_SHORT_TERM_COMMISSION_AMOUNT: 0.3,
};

export default constants;
